import { CandidateProposedVacanciesPage } from '@pages/candidate';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta(
    'Предложенные вакансии',
    'Вакансии, на которые отобран кандидат'
  );
}

export default CandidateProposedVacanciesPage;
